var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getCurrencyConfig, SYMBOL_POSITION, DEFAULT_SEPARATOR_PATTERN, } from '../config';
import { formatNumber } from '../formatNumber';
import { ifNumberValidThen } from '../utils';
export function formatCurrencyNumber(code, input, options) {
    var _a = typeof options === 'object'
        ? options
        : { precision: options, maxPrecision: undefined, noSeparator: undefined }, precision = _a.precision, maxPrecision = _a.maxPrecision, noSeparator = _a.noSeparator;
    var conf = getCurrencyConfig(code);
    var formattedNumber = conf
        ? formatNumber(input, {
            decimalPoint: conf.decimalPoint,
            separator: noSeparator ? void 0 : conf.separator,
            separatorPattern: noSeparator
                ? void 0
                : typeof conf.separatorPattern === undefined
                    ? DEFAULT_SEPARATOR_PATTERN
                    : conf.separatorPattern,
            maxPrecision: ifNumberValidThen(maxPrecision, function (p) { return p; }, maxPrecision === false ? maxPrecision : conf.maxPrecision),
            precision: ifNumberValidThen(precision, function (p) { return p; }, precision === false ? precision : conf.precision),
        })
        : formatNumber(input);
    var isTH = code === 'THB' || code === 'TH';
    var isDefaultTHCurrencySetting = precision === undefined;
    if (isTH && isDefaultTHCurrencySetting) {
        if (typeof formattedNumber === 'string' &&
            !!/\.\d$/.exec(formattedNumber)) {
            formattedNumber += '0';
        }
    }
    return formattedNumber;
}
export function formatCurrency(code, input, options) {
    var num = typeof input === 'number' ? input : parseFloat(input);
    var isNegative = num < 0;
    var formattedNumber = String(formatCurrencyNumber(code, Math.abs(num), options));
    return _addCurrencySymbols(formattedNumber, isNegative, code, options);
}
function applyOptions(config, options) {
    if (typeof options === 'object') {
        config = __assign({}, config);
        if (typeof options.symbolPosition === 'string') {
            config.symbolPosition = options.symbolPosition;
        }
        if (config.symbolPosition === 'FRONT_AND_BACK') {
            if (Array.isArray(options.symbol) &&
                typeof options.symbol[0] === 'string' &&
                typeof options.symbol[1] === 'string') {
                config.symbol = options.symbol;
            }
            else if (typeof options.symbol === 'string') {
                config.symbol = [options.symbol, options.symbol];
            }
            if (Array.isArray(options.spaceBetweenSymbol) &&
                typeof options.spaceBetweenSymbol[0] === 'boolean' &&
                typeof options.spaceBetweenSymbol[1] === 'boolean') {
                config.spaceBetweenSymbol = options.spaceBetweenSymbol;
            }
            else if (typeof options.spaceBetweenSymbol === 'boolean') {
                config.spaceBetweenSymbol = [
                    options.spaceBetweenSymbol,
                    options.spaceBetweenSymbol,
                ];
            }
        }
        else {
            if (typeof options.symbol === 'string') {
                config.symbol = options.symbol;
            }
            if (typeof options.spaceBetweenSymbol === 'boolean') {
                config.spaceBetweenSymbol = options.spaceBetweenSymbol;
            }
        }
    }
    return config;
}
export function _addCurrencySymbols(formattedNumber, isNegative, code, options) {
    var config = applyOptions(getCurrencyConfig(code), options);
    var sign = isNegative ? '-' : '';
    var space = function (value) { return (value ? ' ' : ''); };
    if (config.symbolPosition === SYMBOL_POSITION.FRONT_AND_BACK) {
        return (sign +
            config.symbol[0] +
            space(config.spaceBetweenSymbol[0] && !!config.symbol[0] && !!formattedNumber) +
            formattedNumber +
            space(config.spaceBetweenSymbol[1] && !!config.symbol[1] && !!formattedNumber) +
            config.symbol[1]);
    }
    else if (config.symbolPosition === SYMBOL_POSITION.BACK) {
        return (sign +
            formattedNumber +
            space(config.spaceBetweenSymbol && !!config.symbol && !!formattedNumber) +
            (config.symbol || ''));
    }
    else {
        return (sign +
            (config.symbol || '') +
            space(config.spaceBetweenSymbol && !!config.symbol && !!formattedNumber) +
            formattedNumber);
    }
}
